import React, { useContext } from 'react';

import { Button, Form } from 'semantic-ui-react';

import { isValidHeroTileLayout } from '../../../../services/tile';
import { CustomHeroFormContext } from '../../CustomHeroForm.context';

import './NumberOfTiles.scss';

const propTypes = {};
const defaultProps = {};

export default function NumberOfTiles() {
  const { customHero, setLayout } = useContext(CustomHeroFormContext);
  const { tiles = [], tilesPerRow } = customHero;
  const numberOfTiles = tiles.length;

  const availableNumberOfTiles = [1, 2, 4];

  function onClick(newTilesNumber) {
    setLayout({ tilesPerRow, numberOfTiles: newTilesNumber });
  }

  return (
    <Form.Group className="number-of-tiles">
      <label htmlFor="number-of-tiles">Number of Tiles</label>
      <Button.Group id="number-of-tiles">
        {availableNumberOfTiles.map((currentNumberOfTiles) => (
          <Button
            key={currentNumberOfTiles}
            active={numberOfTiles === currentNumberOfTiles}
            onClick={() => onClick(currentNumberOfTiles)}
            disabled={!isValidHeroTileLayout(currentNumberOfTiles, tilesPerRow)}
          >
            {currentNumberOfTiles}
          </Button>
        ))}
      </Button.Group>
    </Form.Group>
  );
}

NumberOfTiles.propTypes = propTypes;
NumberOfTiles.defaultProps = defaultProps;
